import request from "@/utils/request";

// 发布会落地页使用判断是否需要输入昵称
export const checkNickname = () => {
  return request.get('/backend-api/release/checkNickname');
};

// 获取用户信息
export const getUserInfo = () => {
  return request.get('/user-center/api/app/userInfo');
};

// 修改昵称
export const updateUserNickname = (data: { nickname: string }) => {
  return request.put(`/user-center/api/app/user/nickname?nickname=${data.nickname}`, data);
};

// 性别、生日、城市修改
export const updateUserInfo = (data: Record<string, unknown>) => {
  return request.put('/user-center/api/app/user', data);
};

// 修改学科
export const updateSubject = (subject: any) => {
  return request.put(`/user-center/api/app/user/subject?subject=${subject}`);
};

// 修改头像
export const updateUserAvatar = (data: FormData) => {
  return request.post('/user-center/api/app/user/avatar', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// 获取年级列表
export const getSchoolClass = () => {
  return request.get('/user-center/api/app/attr/format/school_class');
};

// 获取地区列表
export const getAreaList = (parentId: number = 0) => {
  return request.get(`/user-center/api/app/attr/area/${parentId}`);
};

// 查询学员收货地址
export const getAddressList = () => {
  return request.get('/user-center/api/app/address');
};

// 设置默认的收货地址
export const setDefaultAddress = (id: number) => {
  return request.put(`/user-center/api/app/attr/area/${id}`);
};

//修改地址
export const updateAddress = (id: number, data: Record<string, unknown>) => {
  return request.put(`/user-center/api/app/address/${id}`, data);
};

// 删除地址
export const deleteAddress = (id: number) => {
  return request.delete(`/user-center/api/app/address/${id}`);
};

// 新增地址
export const addAddress = (data: Record<string, unknown>) => {
  return request.post('/user-center/api/app/address', data);
};

// 注销用户
export const cancelAccount = (smsCode: string) => {
  return request.delete(`/user-center/api/app/cancel/account/${smsCode}`);
};